import React, { useState } from "react";
import ReturnReplace from "./ReturnReplace";
import FinalConfirmation from "../your_order/CancelConfirmation";
import StepRefundPayment from "../your_order/StepRefundMethod";

const ReplaceSteps = ({
  setIsReplace,
  orderID,
  orderData,
  refetch,
  setOpenOrder,
}) => {
  const [step, setStep] = useState(1);
  const [cancelReason, setCancelReason] = useState(null);
  const [additionalComments, setAdditionalComments] = useState("");
  const [refundMethod, setRefundMethod] = useState("");
  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);
  const [uploadedImage, setUploadedImage] = useState(null); // store uploaded image
  const [selectedQty, setSelectedQty] = useState(orderData?.quantity || "");

  return (
    <div className="max-w-[800px] mx-auto">
      {step === 1 && (
        <ReturnReplace
          pageTitle={"Replace"}
          orderData={orderData}
          orderID={orderID}
          cancelReason={cancelReason}
          setCancelReason={setCancelReason}
          additionalComments={additionalComments}
          setAdditionalComments={setAdditionalComments}
          isReplace={true}
          setIsReplace={setIsReplace}
          onNext={handleNext}
          setStep={setStep}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          selectedQty={selectedQty}
          setSelectedQty={setSelectedQty}
        />
      )}

      {step === 2 && (
        <StepRefundPayment
          onNext={handleNext}
          refundMethod={refundMethod}
          setRefundMethod={setRefundMethod}
          setCancelReason={setCancelReason}
          onBack={handleBack}
          orderData={orderData}
          orderID={orderID}
          isReplace={true}
          setStep={setStep}
        />
      )}
      {step === 3 && (
        <FinalConfirmation
          setClose={setIsReplace}
          type={"Replace"}
          refetch={refetch}
          setOpenOrder={setOpenOrder}
        />
      )}
    </div>
  );
};

export default ReplaceSteps;
